import React from 'react'
import "../App.css";

export const Header = () => {
    return (
        <h2 className="glow">
            Expense Tracker
        </h2>
    )
}
